import React, { useState, useEffect } from "react";
import LoadingOverlay from "react-loading-overlay";
import { PacmanLoader } from "react-spinners";

export default function MatchLoadingOverlay({ isActive }) {
  const [show, setshow] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setshow(false);
    }, 1500);
  }, []);
  return (
    <LoadingOverlay
      active={show}
      styles={{
        wrapper: {},
      }}
      spinner={<PacmanLoader color="#fff" />}
    ></LoadingOverlay>
  );
}
